import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const MapIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M18.257 3.6849L14.969 4.9999L9.664 3.2319C9.215 3.0819 8.728 3.0969 8.289 3.2719L4.257 4.8849C3.498 5.1889 3 5.9239 3 6.7419V18.5869C3 20.0019 4.429 20.9689 5.743 20.4439L9.032 19.1289L14.337 20.8969C14.786 21.0469 15.273 21.0319 15.712 20.8569L19.743 19.2439C20.502 18.9399 21 18.2049 21 17.3869V5.5419C21 4.1269 19.571 3.1589 18.257 3.6849ZM15 17.6049C15 18.2859 14.334 18.7679 13.687 18.5549L9.687 17.2369C9.277 17.1019 9 16.7189 9 16.2869V6.5239C9 5.8429 9.666 5.3609 10.313 5.5739L14.313 6.8919C14.723 7.0269 15 7.4099 15 7.8419V17.6049Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

MapIcon.propTypes = {
  sx: PropTypes.object,
};

export default MapIcon;
